import 'swiper/css'

import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

const images = [
    'https://ik.imagekit.io/238r9emirjj/post-payment-updates/zepto_logo.svg.svg?updatedAt=1727678185310',
    'https://ik.imagekit.io/238r9emirjj/post-payment-updates/Frame%2022058.svg?updatedAt=1727678235784',
    'https://ik.imagekit.io/238r9emirjj/post-payment-updates/Frame%2022059.svg?updatedAt=1727678383056',
    'https://ik.imagekit.io/238r9emirjj/post-payment-updates/Frame%2022060.svg?updatedAt=1727678666503',
    'https://ik.imagekit.io/238r9emirjj/post-payment-updates/Frame%2022059%20(1).svg?updatedAt=1727678715402',
    'https://ik.imagekit.io/238r9emirjj/post-payment-updates/Frame.svg?updatedAt=1727678768412',
    'https://ik.imagekit.io/238r9emirjj/post-payment-updates/Logo.svg.svg?updatedAt=1727678808635'
]

const CompaniesSection = () => {

    return (
        <div className=''>
            <Swiper
                spaceBetween={8}
                slidesPerView={2.7}
                freeMode={false}
                loop={true}
                autoplay={{
                    delay: 0,
                    disableOnInteraction: false
                }}
                speed={5000}
                modules={[Autoplay ]}
                className="mySwiper"
                
            >
                {images.map((image, index) => (
                    <SwiperSlide key={index} className='w-full'>
                        <img src={image} className='w-full h-auto' alt="" />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default CompaniesSection